import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";
import { BadgeTagsWithIcons } from "../../../../Constant";
import { ICON_CONTEXT, ICON_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";

const BadgeTagsWithIconsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={BadgeTagsWithIcons} span={ICON_DATA} />
        <CommomTagAndPillsCardBody number={ICON_CONTEXT} />
      </Card>
    </Col>
  )
};

export default BadgeTagsWithIconsCart;